import { useEffect, useState } from 'react'
import ItemCard from './ItemCard';
import { Grid, Skeleton, Box, Typography, Container } from '@mui/material';
import { useSelector } from 'react-redux';
import { getTopDishes } from '../../functions/orders';
import Lottie from 'react-lottie';
import { motion } from "framer-motion";
import * as animationData from '../../data/food.json'
import { RiBoxingFill } from 'react-icons/ri';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

const MenuItems = ({ count = 3, order = null, searchValue = null }) => {
    const [menuItems, setMenuItems] = useState([]);
    const [loading, setLoading] = useState(false)
    const { currentBranch } = useSelector((state) => state.branch);
    const branchId = currentBranch?.id;
      
    useEffect(() => {
        setLoading(true);
        getTopDishes(branchId).then(res => {
            const { data: { data } } = res;
            console.log('Top dishes', data);
            setMenuItems(data);
            setLoading(false);
        })
    }, [])

    const handleSearch = () => {
        return searchValue ? menuItems.filter(item => item.food_name.toLowerCase().includes(searchValue.toLowerCase())) : menuItems
    };

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: `repeat(${count}, 1fr)`,
                gap: 2,
                overflow: "hidden",
                width: "100%",
            }}
        >
            {!loading && handleSearch().length > 0 && handleSearch()?.map((item) => (
                <Box item xs={count} sx={{ width: "100%" }}>
                    <ItemCard item={item} order={order} />
                </Box>
            ))}

            {loading && Array(6).fill(0).map((__, i) => (
                <Box key={i}>
                    <Skeleton variant="rectangular" width={"100%"} height={140} />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="text" sx={{ fontSize: '.5rem' }} />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                </Box>
            ))}
        </Box>
    )
}

export default MenuItems